module.exports = __webpack_public_path__ + "static/media/IXP-android-scan-code.2b801fdc.png";